import { IconType } from "./icons.types";

export const ChartIcon = ({ className, color = "#4AD991" }: IconType) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.14473 33.5186H35.2558C36.4013 33.5186 37.3299 34.4472 37.3299 35.5926C37.3299 36.7381 36.4013 37.6667 35.2558 37.6667H2.07066C0.925177 37.6667 -0.00341797 36.7381 -0.00341797 35.5926V2.40745C-0.00341797 1.26197 0.925177 0.333374 2.07066 0.333374C3.21614 0.333374 4.14473 1.26197 4.14473 2.40745V33.5186Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M11.88 24.5667C11.0966 25.4024 9.78405 25.4447 8.94838 24.6613C8.11271 23.8778 8.07037 22.5653 8.85381 21.7296L16.6316 13.4333C17.3893 12.6251 18.6483 12.555 19.491 13.2742L25.6297 18.5125L33.6279 8.3815C34.3377 7.48243 35.6419 7.32899 36.541 8.03878C37.4401 8.74857 37.5935 10.0528 36.8837 10.9519L27.5504 22.7741C26.8214 23.6975 25.4711 23.8303 24.5762 23.0666L18.3041 17.7144L11.88 24.5667Z"
        fill={color}
      />
    </svg>
  );
};
